import { keysToCamel } from '#/api/adapters/wireCase';

/**
 * Form-cache Ver4 envelope；`data` 可為 null（GET 無草稿／已過期）。
 * @param {object} raw
 */
export function parseFormCacheEnvelope(raw) {
  return {
    message: raw?.message,
    route: raw?.route,
    data: raw?.data == null ? null : keysToCamel(raw.data),
  };
}
